import { partyMasterConfig } from './partyMaster';

/**
 * Dispatcher master (redesigned 2026-10-16, migration 035). A balance in a currency is what the dispatcher holds for you; amber means it is below the currency's
 * Low balance alert (time to top it up), red means you owe the dispatcher. Only currencies marked "Dispatcher currency" can be added.
 */
export const dispatchersConfig = partyMasterConfig({
  title: 'Dispatchers', singular: 'dispatcher', icon: 'truck', menu: 'suppliers', endpoint: '/suppliers',
  balances: 'suppliers', idKey: 'supplierId', lookup: 'suppliers', balanceHeader: 'Balance held',
  directions: [{ value: 'hold', label: 'Dispatcher holds for you' }, { value: 'owe', label: 'You owe the dispatcher' }],
  tips: ['Held for you', 'You owe the dispatcher'],
  totalsTitle: 'Held by dispatchers (active), by currency',
  note: 'Balance in a currency is what the dispatcher holds for you. Amber means below the low balance alert. Red means you owe the dispatcher.',
  currenciesHelp: 'Only currencies marked "Dispatcher currency" are listed',
  activeHelp: 'Inactive dispatchers are hidden from dropdowns',
  locationHelp: 'For example Muscat, Ruwi',
  eligible: (c) => c.isSupplier === true,
  extra: {
    apiField: 'lowBalanceAlert', label: 'Low balance alert', help: 'Warn when below', kind: 'low',
    tip: (amount) => `Below the alert level of ${amount}`,
    filter: { param: 'lowBalance', label: 'Low balance only' },
  },
});
